import { FC, useState } from 'react';

import Collapse from '@components/Collapse/Collapse';

import {
  CollapsibleFilterItemsWrapper,
  MultiSelectionFilterWrapper,
  ShowMoreButton,
  Title,
} from './MultiSelectionFilterStyle';
import MultiSelectionFilter from './MultiSelectionFilter';
import { CollapsibleMultiSelectionFilterProps } from './types';

const panelKey = 'filter-panel';
const VISIBLE_ITEMS_LIMIT = 5;
const SCROLLABLE_ITEMS_THRESHOLD = 10;

const CollapsibleMultiSelectionFilter: FC<
  CollapsibleMultiSelectionFilterProps
> = ({
  title,
  selectedItems,
  showSelectedItemsCount,
  collapseProps,
  withValue,
  showMore = true,
  data,
  ...multiSelectionFilterProps
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const {
    panelProps: {
      showArrow = true,
      key = panelKey,
      header = (
        <Title>
          {title}
          {showSelectedItemsCount ? (
            <span>({selectedItems.length} Seçildi)</span>
          ) : null}
        </Title>
      ),
      ...otherPanelProps
    } = {},
    ...otherCollapseProps
  } = collapseProps || {
    panelProps: {
      showArrow: true,
      key: panelKey,
      header: (
        <Title>
          {title}
          {showSelectedItemsCount ? (
            <span>({selectedItems.length} Seçildi)</span>
          ) : null}
        </Title>
      ),
    },
  };

  const { footer, ...otherMultiSelectionFilterProps } =
    multiSelectionFilterProps;

  const items =
    showMore && !isExpanded ? data?.slice(0, VISIBLE_ITEMS_LIMIT) : data;
  const hasMore = showMore && (data?.length || 0) > VISIBLE_ITEMS_LIMIT;

  return (
    <MultiSelectionFilterWrapper>
      <Collapse
        defaultActiveKey={selectedItems.length ? panelKey : undefined}
        panelProps={{
          showArrow,
          key,
          header,
          ...otherPanelProps,
        }}
        {...otherCollapseProps}
      >
        <CollapsibleFilterItemsWrapper
          $isScrollable={
            isExpanded && (data?.length || 0) > SCROLLABLE_ITEMS_THRESHOLD
          }
        >
          <MultiSelectionFilter
            data={items}
            selectedItems={selectedItems}
            withValue={withValue}
            {...otherMultiSelectionFilterProps}
          />
        </CollapsibleFilterItemsWrapper>
        {hasMore ? (
          <ShowMoreButton
            type='button'
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            {isExpanded ? 'Daha Az Göster' : 'Daha Fazla Göster'}
          </ShowMoreButton>
        ) : null}
        {footer}
      </Collapse>
    </MultiSelectionFilterWrapper>
  );
};

export default CollapsibleMultiSelectionFilter;
